export default __webpack_public_path__ + "static/globe-still-square-008a7ccf7adb33f2adfb146520368b1c.png";